export default __webpack_public_path__ + "static/media/Shoulder Strap of Bone and Horn.f0afee6c.jpg";